<ng-template #content let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="{{ modalId }}">Add Entry</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <div class="input-group mb-3">
                <input [(ngModel)]="entry.name" type="text" class="form-control" placeholder="Entry Name" aria-label="Entry name">
            </div>
            <div class="input-group mb-3">
                <input [(ngModel)]="entry.lane" type="text" class="form-control" placeholder="Lane" aria-label="Lane">
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" [disabled]="entry.name?.trim() =='' || !entry.name" (click)="add()">Save</button>
    </div>
</ng-template>

<button *ngIf="auth.currentUser" class="btn btn-outline-primary" (click)="open(content)">Create New Entry</button>